import React from "react";
import { Link } from "react-router-dom";
import ServiceCarousel from "./ServiceCarousel";

// 🔹 Import separate images for each service
// Make sure these filenames match what you actually have in src/assets
import mortgagesImg from "../assets/loan-mortgages.jpg";
import firstHomeImg from "../assets/loan-first-home.png";
import investmentImg from "../assets/loan-investment.png";
import refinancingImg from "../assets/loan-refinancing.jpg";
import constructionImg from "../assets/loan-construction.jpg";
import commercialImg from "../assets/loan-commercial.jpg";

const loanServices = [
  {
    id: "mortgages",
    title: "Mortgages",
    tagline: "Home loan specialists",
    description:
      "We compare home loans across the major New Zealand banks and specialist lenders, then structure yours around your deposit and income rather than the bank’s default setting.",
    image: mortgagesImg,
  },
  {
    id: "first-home-buyers",
    title: "First Home Buyers",
    tagline: "Buying your first place",
    description:
      "Budgeting, pre-approval, KiwiSaver, the First Home Grant, then settlement. We explain each step as you get to it, so nothing catches you off guard.",
    image: firstHomeImg,
  },
  {
    id: "investment-property",
    title: "Investment Property",
    tagline: "Property investment finance",
    description:
      "Lending for rentals and growing portfolios, including interest-only options and splitting your lending across more than one bank. Most investors don’t think about that until they need to.",
    image: investmentImg,
  },
  {
    id: "refinancing",
    title: "Refinancing",
    tagline: "Better rates & loan reviews",
    description:
      "We look at what you’re paying now and check whether another lender would do better on rate, cash-back or structure. If you’re better off where you are, we’ll tell you.",
    image: refinancingImg,
  },
  {
    id: "construction-loans",
    title: "Construction Loans",
    tagline: "Building & renovation finance",
    description:
      "Finance for new builds, renovations and extensions. Construction lending pays out in stages, so we keep the drawdowns lined up between your builder and the bank.",
    image: constructionImg,
  },
  {
    id: "commercial-property",
    title: "Commercial Property",
    tagline: "Business property mortgages",
    description:
      "Lending for premises you will occupy yourself or lease out. Commercial deals turn on your cashflow and the lease profile, so that is where we start.",
    image: commercialImg,
  },
];

function LoanServicesSection() {
  return (
    <section className="section loan-services-section">
      <div className="section-header">
        <span className="section-kicker">Loans</span>
        <h2 className="section-title">
          The lending we arrange most often.
        </h2>
        <p className="section-subtitle">
          Every lender has its own rules about who it will lend to and how much.
          We know those rules, so we can point you at the ones likely to say yes
          before you start filling in forms.
        </p>
      </div>

      <ServiceCarousel label="Loan services">
        {loanServices.map((service) => (
          <div className="loan-loop-card" key={service.id}>
            <div className="loan-card-image">
              <img src={service.image} alt={service.title} />
            </div>

            <div className="loan-card-content">
              <div className="loan-card-tag">{service.tagline}</div>
              <h3 className="loan-card-title">{service.title}</h3>
              <p className="loan-card-description">{service.description}</p>

              <Link to={`/services/${service.id}`} className="loan-card-link">
                Learn more about {service.title.toLowerCase()}
              </Link>
            </div>
          </div>
        ))}
      </ServiceCarousel>
    </section>
  );
}

export default LoanServicesSection;
